<template>
  <div>
    <p
      v-if="label"
      class="small font-weight-bold text-gray-400 mb-0"
      v-text="label"
    />
    <slot />
  </div>
</template>
<script>
export default {
  name: 'TextLabeled',
  props: {
    label: {
      type: String,
      required: false,
      default: '',
    },
  }
}
</script>
